import React from 'react';
import DaApp from '@wix/da-shared-react/pkg/DaApp';
import { RuntimeEnvironment } from '@wix/da-shared-react/pkg/types';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import SharedDeviationPage from '@wix/da-shared-react/pkg/DeviationPage';
import { PapiDeviation } from '@wix/da-papi-types';
import './App.scss';

export interface Props {
  language: string;
  deviation?: PapiDeviation;
  environment?: RuntimeEnvironment;
  appLoaded: () => void;
}

class App extends React.Component<Props> {
  componentDidMount() {
    this.props.appLoaded();
  }

  render() {
    const { deviation, language, environment } = this.props;

    return (
      <DaApp
        language={language}
        environment={environment}
        backToTopOffset={0}
        isDuperbrowseEnabled={false}
        disablePageWideNotifications
      >
        <ErrorBoundary>
          <SharedDeviationPage
            deviation={deviation}
            environment={environment}
          />
        </ErrorBoundary>
      </DaApp>
    );
  }
}

export default App;
